import React, { Component } from 'react';

import { ILoanAccountActivity } from '../../../interfaces';
import { FormattingUtils } from '../../../utils';

import LoanAccountActivity from './LoanAccountActivity';

const { formatDate, formatMoney } = FormattingUtils;

interface IProps {
  activity: ILoanAccountActivity;
}

class LoanCreated extends Component<IProps> {
  public render () {
    const { data } = this.props.activity
      // Labeled as the columns of the Loans tab are, so the same loan reads the same way in both.
      , activityBody = (
        <div>
          <h3>Loan Created</h3>
          <p><span className='status'>Loan Id:</span> {data.loan_vanity_id}</p>
          <p><span className='status'>Initial Principal:</span> {formatMoney(data.initial_principal_amount)}</p>
          <p><span className='status'>Origination:</span> {formatDate(data.origination_date)}</p>
        </div>
      )
      ;

    // Passed explicitly rather than spread: a spread would let a prop added upstream override the
    // dot and icon this component picked, and the failure would be a wrong icon rather than an error.
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='plus'
      />
    );
  }
}

export default LoanCreated;
